<template>
  <kst-table resizable action input-mode :data="userItems">
    <b-table-column
      v-slot="{ column, row, index }"
      field="DispatchID"
      :label="RinvItemCatalog.DispatchID.ColumnLabel"
    >
      <div class="ks-col-input-grow">
        <kst-tooltip v-if="row.Errors.length > 0" error-mode>
          <template #content>
            <kst-list :items="row.Errors"/>
          </template>
          <kst-icon error-mode/>
        </kst-tooltip>

        <kst-input box-off field-only class="is-hidden"
          field="DispatchID" :data="row" :catalog="RinvItemCatalog"
          :index="index" @error="handleRowErrors"
        />

        <kst-output box-off field-only
          :field="column.field" :data="row" :catalog="RinvItemCatalog"
          :index="index"
        />

        <kst-tooltip info-mode>
          <template #content>
            <kst-list info-mode :items="Model.Edit.getItemInfo(row)"/>
          </template>
          <kst-icon info-mode/>
        </kst-tooltip>
      </div>
    </b-table-column>

    <b-table-column
      v-slot="{ column, row }"
      cell-class="ks-col-packaging"
      field="Packaging"
      :label="RinvItemCatalog.Packaging.Label"
    >
      <kst-output box-off field-only
        :field="column.field" :data="row" :catalog="RinvItemCatalog"
      />
    </b-table-column>

    <b-table-column
      v-slot="{ column, row, index }"
      cell-class="ks-col-qty"
      field="Quantity"
      :label="RinvItemCatalog.Quantity.Label"
    >
      <kst-input error-off field-only
        :field="column.field" :data="row" :catalog="RinvItemCatalog"
        :index="index" @input="handleQuantity(row)" @error="handleRowErrors"
      />
    </b-table-column>

    <b-table-column numeric
      v-slot="{ column, row, index }"
      cell-class="ks-col-price"
      field="SellPrice"
      :label="RinvItemCatalog.SellPrice.Label"
    >
      <kst-output box-off field-only
        :field="column.field" :data="row" :catalog="RinvItemCatalog"
        :index="index"
      />
    </b-table-column>

    <b-table-column
      v-if="hasItemLevelDisc"
      v-slot="{ column, row, index }"
      cell-class="ks-col-disc-type"
      field="DiscType"
      :label="RinvItemCatalog.DiscType.Label"
    >
      <kst-input error-off field-only
        :field="column.field" :data="row" :catalog="RinvItemCatalog"
        :index="index" :options="row.DiscTypeOptions"
        @input="handleDiscType(row)" @error="handleRowErrors"
      />
    </b-table-column>

    <b-table-column
      v-if="hasItemLevelDisc"
      v-slot="{ column, row, index }"
      cell-class="ks-col-disc-value"
      field="DiscValue"
      :label="RinvItemCatalog.ItemDiscValue.Label"
    >
      <template v-if="row.DiscType === Model.DiscType.Value.ID">
        <kst-input error-off field-only
          field="DiscValue" :data="row" :catalog="RinvItemCatalog"
          :index="index" @input="handleDiscValue(row)" @error="handleRowErrors"
        >
        </kst-input>
      </template>
      <template v-else-if="row.DiscType === Model.DiscType.Percent.ID">
        <kst-input error-off field-only
          field="DiscPercent" :data="row" :catalog="RinvItemCatalog"
          :index="index" @input="handleDiscPercent(row)" @error="handleRowErrors"
        />
      </template>
      <template v-else>
        <input class="input is-invisible"/>
      </template>
    </b-table-column>

    <b-table-column numeric
      v-slot="{ column, row }"
      cell-class="ks-col-subtotal"
      field="TotalAfterDisc"
      :label="RinvItemCatalog.Total.Label"
    >
      <kst-output box-off field-only
        :field="column.field" :data="row" :catalog="RinvItemCatalog"
      />
    </b-table-column>

    <template #action="{ index }">
      <kst-tooltip delete-mode hover-only :content="Model.RtnInvoiceItem.Module.FullName">
        <kst-button delete-mode is-round @click="handleRowDelete(index)"/>
      </kst-tooltip>
    </template>

    <template #empty-body>
      <ValidationProvider v-slot="{ errors }" name="userItems" rules="required">
        <kst-error :array-blank-mode="!!errors"/>
      </ValidationProvider>
    </template>
  </kst-table>
</template>

<script>
import DialogMixin from "../../../mixins/DialogMixin.js";
import AppModuleAttr from "../../../services/App/AppModuleAttr.js";
import Info from "../RinvInfo.js";
import Model from "../RinvModel.js";
import RinvItemCatalog from "../RinvItemCatalog.js";

export default {
  mixins: [DialogMixin],
  props: {
    userData: Object,
    userItems: Array
  },
  data: () => ({
    Model: Model,
    RinvItemCatalog: RinvItemCatalog
  }),
  computed: {
    hasItemLevelDisc() {
      return this.$kst.Access.hasModuleAttr(AppModuleAttr.ItemLevelDisc_Act_List);
    }
  },
  methods: {
    handleQuantity(item) {
      Model.validateItem(item);
      Model.updateItem(item);
      Model.updateDetails(this.userData, this.userItems);
    },

    handleDiscType(item) {
      if (item.DiscType === Model.DiscType.None.ID) {
        item.DiscValue = "";
        item.DiscPercent = "";
      }

      Model.updateItem(item);
      Model.updateDetails(this.userData, this.userItems);
    },
    handleDiscValue(item) {
      Model.updateItem(item);
      Model.updateDetails(this.userData, this.userItems);
    },
    handleDiscPercent(item) {
      Model.updateItem(item);
      Model.updateDetails(this.userData, this.userItems);
    },

    handleRowDelete(index) {
      this.showConfirm(
        Info.Message.New_ConfirmDeleteItem,
        this.handleRowDelete_Confirm,
        null,
        index
      );
    },
    handleRowDelete_Confirm(index) {
      this.userItems.splice(index, 1);
      Model.updateDetails(this.userData, this.userItems);
    },

    handleRowErrors(errors, field, index) {
      Model.setItemErrors(this.userItems[index], field, errors);
    }
  }
}
</script>